/** H5 游戏库（docs/API.md 2.6.1）：所有家庭共用，不参与同步，用时现取 */
import { api } from "../core/api";
import type { JSONObject } from "../core/models";

export interface WebPackage {
  id: string;
  version: string;
  name: string;
  description: string | null;
  tags: string[];
  estimatedMin: number | null;
  reportsScore: boolean;
  /** 设置项 Schema（内部键名原样，见 core/json.ts OPAQUE_KEYS） */
  paramsSchema: JSONObject | null;
  assetId: string;
  builtin: boolean;
  /** data URL */
  icon: string | null;
  status: "active" | "hidden";
}

/** 每个游戏最新的可用版本 */
export async function listGames(): Promise<WebPackage[]> {
  return (await api.get<{ packages: WebPackage[] }>("web-packages")).packages;
}

/** 某个游戏的所有版本（新的在前，含已下架的） */
export async function gameVersions(id: string): Promise<WebPackage[]> {
  return (await api.get<{ versions: WebPackage[] }>(`web-packages/${encodeURIComponent(id)}`)).versions;
}

/** 内容 payload 里写的版本；没有（或已删除）时用最新的 */
export async function gameOf(id: string, version: string | null): Promise<WebPackage | null> {
  const list = await gameVersions(id);
  return list.find((v) => v.version === version) ?? list[0] ?? null;
}
